import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const plans = [{
  name: 'Базовый',
  price: '$40',
  period: '/ мес.',
  isCurrent: false
}, {
  name: 'Стандарт',
  price: '$100',
  period: '/ 3 мес.',
  isCurrent: true
}, {
  name: 'Премиум',
  price: '$300',
  period: '/ год',
  isCurrent: false
}];
const paymentHistory = [{
  id: '1',
  date: '15 декабря 2025',
  amount: '$100',
  status: 'Оплачено'
}, {
  id: '2',
  date: '15 сентября 2025',
  amount: '$100',
  status: 'Оплачено'
}, {
  id: '3',
  date: '15 июня 2025',
  amount: '$100',
  status: 'Оплачено'
}];
export function SubscriptionScreen() {
  return <div className="min-h-screen bg-svt-bg" data-id="element-302">
      {/* Header */}
      <div className="sticky top-0 z-40 bg-svt-bg/80 backdrop-blur-xl border-b border-svt-border transition-colors duration-300" data-id="element-303">
        <div className="flex items-center justify-between px-6 py-4" data-id="element-304">
          <h1 className="text-2xl font-bold text-svt-text" data-id="element-305">Подписка</h1>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6 space-y-6" data-id="element-306">
        {/* Current Plan Card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="relative rounded-3xl overflow-hidden bg-svt-card border border-svt-border p-6" data-id="element-307">
          <div className="absolute top-0 right-0 w-40 h-40 bg-gradient-primary opacity-10 blur-3xl rounded-full" data-id="element-308"></div>

          <div className="relative" data-id="element-309">
            <div className="flex items-start justify-between mb-4" data-id="element-310">
              <div data-id="element-311">
                <h2 className="text-xl font-bold text-svt-text mb-1" data-id="element-312">
                  Текущий план
                </h2>
                <p className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-313">
                  Стандарт
                </p>
              </div>
              <div className="px-3 py-1.5 rounded-full bg-green-500/20 border border-green-500/30 text-green-400 text-xs font-bold" data-id="element-314">
                Активна
              </div>
            </div>

            <div className="flex items-baseline gap-2 mb-2" data-id="element-315">
              <span className="text-3xl font-bold text-svt-text" data-id="element-316">$100</span>
              <span className="text-svt-text-muted" data-id="element-317">/ 3 месяца</span>
            </div>

            <p className="text-sm text-svt-text-muted" data-id="element-318">
              Действует до{' '}
              <span className="text-svt-text font-medium" data-id="element-319">15 марта 2026</span>
            </p>
          </div>
        </motion.div>

        {/* Plan Options */}
        <div data-id="element-320">
          <h3 className="text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-4" data-id="element-321">
            Доступные тарифы
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-322">
            {plans.map((plan, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 + index * 0.05
          }} className={`relative p-6 rounded-2xl flex flex-col transition-all duration-300 ${plan.isCurrent ? 'bg-svt-card-highlight border border-svt-pink/40 shadow-[0_0_20px_rgba(232,67,147,0.1)]' : 'bg-svt-card-alt border border-svt-border hover:border-svt-border-hover'}`} data-id="element-323">
                <div className="flex items-center justify-between mb-4" data-id="element-324">
                  <h4 className="text-lg font-bold text-svt-text" data-id="element-325">
                    {plan.name}
                  </h4>
                  {plan.isCurrent && <div className="w-6 h-6 rounded-full bg-gradient-primary flex items-center justify-center" data-id="element-326">
                      <Check size={14} className="text-white" data-id="element-327" />
                    </div>}
                </div>

                <div className="flex items-baseline gap-1 mb-6" data-id="element-328">
                  <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-svt-pink to-svt-purple" data-id="element-329">
                    {plan.price}
                  </span>
                  <span className="text-svt-text-muted" data-id="element-330">{plan.period}</span>
                </div>

                <button disabled={plan.isCurrent} className={`w-full py-3 rounded-full font-medium transition-all duration-300 ${plan.isCurrent ? 'bg-svt-surface text-svt-text-muted cursor-not-allowed' : 'border border-svt-pink/50 text-svt-pink-light hover:bg-svt-pink/10 hover:border-svt-pink'}`} data-id="element-331">
                  {plan.isCurrent ? 'Текущий' : 'Выбрать'}
                </button>
              </motion.div>)}
          </div>
        </div>

        {/* Payment History */}
        <div data-id="element-332">
          <h3 className="text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-4" data-id="element-333">
            История платежей
          </h3>
          <div className="space-y-3" data-id="element-334">
            {paymentHistory.map((payment, index) => <motion.div key={payment.id} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.3,
            delay: 0.3 + index * 0.05
          }} className="p-4 rounded-2xl bg-svt-surface border border-svt-border flex items-center justify-between" data-id="element-335">
                <div data-id="element-336">
                  <p className="text-sm font-medium text-svt-text mb-1" data-id="element-337">
                    {payment.date}
                  </p>
                  <p className="text-xs text-svt-text-muted" data-id="element-338">
                    {payment.status}
                  </p>
                </div>
                <div className="text-lg font-bold text-svt-text" data-id="element-339">
                  {payment.amount}
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
}